import { type GridElementPropertyAttentionStatusByCalculationType } from './AttentionStatusRepository';
import {
  anyLoadFlowElementRequiresAttention,
  countLoadFlowIssuesRequiringAttention,
  getLoadFlowIssuesGridElementsIdsRequiringAttention
} from './loadFlow/attentionRequired';
import {
  anyShortCircuitElementRequiresAttention,
  countShortCircuitIssuesRequiringAttention,
  getShortCircuitIssuesGridElementsIdsRequringAttention
} from './shortCircuit/attentionRequired';

export function anyGridElementRequiresAttention(
  statusesByType: GridElementPropertyAttentionStatusByCalculationType
) {
  const anyLoadFlowEvaluatedResultsRequiringAttention =
    anyLoadFlowElementRequiresAttention(statusesByType.loadFlow);

  const anyShortCircuitEvaluatedResultsRequiringAttention =
    anyShortCircuitElementRequiresAttention(statusesByType.shortCircuit);

  return (
    anyLoadFlowEvaluatedResultsRequiringAttention ||
    anyShortCircuitEvaluatedResultsRequiringAttention
  );
}

export function countAllIssuesRequiringAttention(
  statusesByType: GridElementPropertyAttentionStatusByCalculationType
): number {
  const allIssues =
    countShortCircuitIssuesRequiringAttention(statusesByType) +
    countLoadFlowIssuesRequiringAttention(statusesByType);
  return allIssues;
}

export function countAllGridElementsRequiringAttention(
  statusesByType: GridElementPropertyAttentionStatusByCalculationType
): number {
  const gridElementsRequiringAttentionInLoadFlowCalculation =
    getLoadFlowIssuesGridElementsIdsRequiringAttention(statusesByType);
  const gridElementsRequiringAttentionInShortCircuitCalculation =
    getShortCircuitIssuesGridElementsIdsRequringAttention(statusesByType);

  const uniqueElementsCount = new Set([
    ...gridElementsRequiringAttentionInLoadFlowCalculation,
    ...gridElementsRequiringAttentionInShortCircuitCalculation
  ]).size;
  return uniqueElementsCount;
}
